import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import Http from '../../../../Http';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Paper, Typography, Button, Box, Divider, CircularProgress 
} from '@material-ui/core';

class EdiConfig extends FormComponent {
  state = {
    ...this.state,
    logs: [],
    loadingLogs: false,
    syncing: false
  }

  async componentDidMount() {
    const id_cliente = this.props.match.params.id;
    const protocolOptions = [
      { Label: 'SFTP', Value: 'SFTP' },
      { Label: 'AS2', Value: 'AS2' },
      { Label: 'API HTTPS', Value: 'API' }
    ];

    this.FormConfig(
      { 
        defaultUrl: `cliente/${id_cliente}/edi-config`, 
        saveUrl: `cliente/${id_cliente}/edi-config`, 
        backUrl: `/Catalogo/Clientes` 
      },
      new Form([
        Form.Section('Configuración de Conexión EDI'),
        Form.Field('select', 'protocol', 'Protocolo de Transporte', 'SFTP', [Validators.required], 6, protocolOptions),
        Form.Field('text', 'host', 'Servidor / Host', '', [Validators.required], 6),
        Form.Field('number', 'port', 'Puerto', 22, [Validators.required], 4),
        Form.Field('text', 'username', 'Usuario / Username', '', [Validators.required], 8),
        Form.Field('password', 'password', 'Contraseña (SFTP)', '', [], 6),
        Form.Field('textarea', 'ssh_key', 'Llave Privada SSH (Para Llaves SFTP)', '', [], 12),
        
        Form.Section('Rutas de Archivos en Servidor'),
        Form.Field('text', 'inbound_path', 'Ruta de Entrada (Ej: /204/inbound/)', '/INBOUND/', [], 4),
        Form.Field('text', 'archive_path', 'Ruta de Historial/Leídos', '/INBOUND/READED/', [], 4),
        Form.Field('text', 'outbound_path', 'Ruta de Salida (Ej: /214/outbound/)', '/OUTBOUND/', [], 4),
        
        Form.Section('Planificación'),
        Form.Field('text', 'cron_expression', 'Expresión Cron (Ej: 0 * * * * para cada hora)', '0 * * * *', [], 6),
        Form.Field('checkbox', 'active', 'Activo', false, [], 6)
      ], ['Guardar']),
      null
    );

    if (id_cliente) {
      await this.LoadPreds(id_cliente);
      await this.loadLogs(id_cliente);
    }
  }

  // Override LoadPreds to fetch from correct multitenant endpoint
  LoadPreds = async (predId = null, callOnChange = true) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`cliente/${id}/edi-config`);
    if (!Res.error && Res.data) {
      this.setState({ 
        FormData: Form.Patch(this.state.FormData, Res.data, callOnChange) 
      });
    }
    return Res.data;
  }

  loadLogs = async (id_cliente) => {
    this.setState({ loadingLogs: true });
    const Res = await Http.get(`cliente/${id_cliente}/edi-logs`);
    if (!Res.error && Res.data) {
      this.setState({ logs: Res.data.rows || [], loadingLogs: false });
    } else {
      this.setState({ loadingLogs: false });
    }
  }

  triggerSync = async () => {
    this.setState({ syncing: true });
    const Res = await Http.post(`cliente/edi-sync`, {});
    this.setState({ syncing: false });
    if (!Res.error) {
      this.setState({ sbMsg: 'Sincronización completada', sbOpen: true });
      if (this.props.match.params.id) {
        await this.loadLogs(this.props.match.params.id);
      }
    } else {
      this.setState({ sbMsg: 'Error al sincronizar: ' + (Res.errMsg || ''), sbOpen: true });
    }
  }

  render() {
    const { logs, loadingLogs, syncing } = this.state;
    return (
      <Box p={3}>
        <this.FormRender />
        
        <Box mt={4} mb={2}>
          <Divider />
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5">Bitácora de Transacciones EDI</Typography>
          <Button 
            variant="contained" 
            color="secondary" 
            onClick={this.triggerSync} 
            disabled={syncing}
            startIcon={syncing ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {syncing ? 'Sincronizando...' : 'Sincronizar Inbound Ahora'}
          </Button>
        </Box>

        <TableContainer component={Paper}>
          <Table aria-label="edi logs table">
            <TableHead>
              <TableRow>
                <TableCell>Archivo</TableCell>
                <TableCell>Dirección</TableCell>
                <TableCell>Tipo Transacción</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell>Mensaje Error</TableCell>
                <TableCell>Fecha de Procesado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loadingLogs ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : logs.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No se han registrado transacciones para este cliente.
                  </TableCell>
                </TableRow>
              ) : (
                logs.map((log) => (
                  <TableRow key={log.id}>
                    <TableCell>{log.filename || 'N/A'}</TableCell>
                    <TableCell>{log.direction}</TableCell>
                    <TableCell>{log.transaction_type}</TableCell>
                    <TableCell>
                      <span style={{ 
                        color: log.status === 'PROCESSED' ? 'green' : log.status === 'FAILED' ? 'red' : 'orange',
                        fontWeight: 'bold'
                      }}>
                        {log.status}
                      </span>
                    </TableCell>
                    <TableCell style={{ color: 'red', maxWidth: '300px', wordBreak: 'break-all' }}>
                      {log.error_message || ''}
                    </TableCell>
                    <TableCell>
                      {log.processed_at ? new Date(log.processed_at).toLocaleString() : ''}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    )
  }
}

export default withRouter(EdiConfig);
